<template>
    <div class="ti">
        <div>
            <el-button size="mini" type="primary text2" @click="modals" v-if="ERP.isPermission(3003001)">添加区域</el-button>

            <el-input size="mini" class="search" placeholder="请输入区域名称" v-model="search" clearable></el-input>
            <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
        </div>
        <v-divider></v-divider>
        <v-simple-table :height="__TABLE_HEIGHT__">
            <template v-slot:default>
                <thead>
                <tr>
                    <th class="text-left">ID</th>
                    <th class="text-left">区域名称</th>
                    <th class="text-left">项目名称</th>
                    <th class="text-left">创建人</th>
                    <th class="text-left">日期</th>
                    <th class="text-left">操作</th>
                </tr>
                </thead>
                <tbody>
                <tr class="text1" v-for="item in desserts" :key="item.id">
                    <td >{{item.id}}</td>
                    <td >{{item.name}}</td>
                    <td >{{items.name}}</td>
                    <td >{{item.c_name}}</td>
                    <td >{{item.date}}</td>
                    <td >
                    <v-icon style="color: #1867c0;" @click="xiugai( item.id )" v-if="ERP.isPermission(3003003)">mdi-pencil</v-icon>
                    <v-icon  style="color: red;" @click="del( item.id )" v-if="ERP.isPermission(3003004)">mdi-pail-outline</v-icon>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
        <v-divider></v-divider>
        <div class="pages" v-if="desserts">
        <Page :total="total" :page-size="page" @on-change="change"  show-total />
        </div>
        <div class="zhanwu" v-else>没有数据</div>
        <Modal
            v-model="modal1"
            :ok-text="anxiu"
            :loading="loadings"
            title="编辑"
            @on-ok="ok">
            <div>
            <el-form  label-width="80px" style="overflow: auto;height: 600px;" :model="dades">
                <el-form-item label="区域名称" :rules="[{required: true}]">
                    <el-input v-model="dades.name"></el-input>
                </el-form-item>
                <el-form-item label="请选择" :rules="[{required: true}]">
                    <div class="text item">
                        <el-tree
                        :props="datas"
                        :data="dataarr"
                        lazy
                        :load="loadNode"
                        show-checkbox
                        ref="tree"
                        node-key="id"
                        includeHalfChecked="false"
                        :default-checked-keys="defaultcheckedkeys"
                        :default-expanded-keys="[]">
                        </el-tree>
                    </div>
                </el-form-item>
            </el-form>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    name: "pindexRegionDate",
    data(){
        return {
            loadings:true,
            items:[],
            dades: {
              id:'',
              name:'',
              pid:'',
              list:[],
              listid:"",
            },
            datas:{
              label: 'label',
              children: 'zones',
              isLeaf: 'leaf',
              value: 'id',
              value1:'region',
              varue2:'type',
              value3:'pindex_id',
            },
            anxiu:'保存',
            modal1: false,
            input1: '',
            desserts: '',
            total:0,
            page:12,
            search:'',
            defaultcheckedkeys:[],
            defaultcheckedkeyssa:[],
            dataarr: [{
                id: 1,
                typa:1,
                label: '加载中',
            }],
            dadetree:[],
        }
    },
    created(){
        var item = JSON.parse(this.$route.query.iten);
        this.items = item;
    },
    mounted(){
      ERP.showLoading()
        this.$Loading.start();
        var pid = this.items.id;
        var t = Date.parse(new Date()) / 1000;//时间戳
        this.$myhttp.get('admin/region?id=1'+'&t='+t+"&pid="+pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.$Loading.finish();
          ERP.hideLoading()
        });
    },
    computed:{
      __TABLE_HEIGHT__(){
        return ERP.getStore().__TABLE_HEIGHT__
      }
    },
    //事件
    methods:{
        //绑定（懒加载方法）
        loadNode(node, resolve) {
            var region_id = this.dades.id;
            console.log(region_id);
            var _this = this;
            setTimeout(() => {
              if(this.dataarr[0].pindex_id == '' || this.dataarr[0].pindex_id == undefined){
                return false;
              }
              //加载
              node.data.region_id = region_id;
              _this.defaultcheckedkeys = [];
              node.data && this.$myhttp.post('admin/Region/getbindingArrs',node.data,{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                // _this.defaultcheckedkeys =  _this.arr;
                _this.defaultcheckedkeys=_this.dadetree;
                return resolve(backdata.data);
              });
            }, 300);
        },

        //弹窗添加
        modals(){
            this.$Loading.start();
            this.anxiu = "保存";
            var pid = this.items.id;
            var name = this.items.name;
            this.dades = {id:'',name: ''};
            this.$myhttp.get('admin/regionSelectAdd?id='+pid+"&name="+name,{
                'Content-Type': 'application/json'
                }).then(backdata=>{ // 异步执行成功后
                // console.log(backdata.data)
                if(backdata.data == 203){
                    this.$Message.success('还没有导入房产!');
                    this.$Loading.finish();
                    return false;
                }
                let data = backdata.data;
                //1级树
                this.dataarr = [{'label':data[0].label,'id':data[0].id,'region':0,'type':1,'pindex_id':data[0].id,superior:'0'}]
                this.defaultcheckedkeys = [];
                this.dadetree = [];
                //console.log(this.dataarr)
                this.$Loading.finish();
                this.modal1 = true;
            });
        },
        //获得当前多少页,分页
        change(e){
          var pid = this.items.id;
          ERP.showLoading()
            this.$Loading.start();
            var t = Date.parse(new Date()) / 1000;//时间戳
            this.$myhttp.get('admin/region?id='+ e + '&search='+ this.search+'&t='+t+"&pid="+pid,{
                'Content-Type': 'application/json'
                }).then(backdata=>{ // 异步执行成功后
                this.desserts = backdata.data[0];
                this.total = backdata.data[1];
                this.page = backdata.data[2];
                this.$Loading.finish();
              ERP.hideLoading()
            });
        },
        //搜索
        searchs(){
          var pid = this.items.id;
          ERP.showLoading()
            this.$Loading.start();
            var t = Date.parse(new Date()) / 1000;//时间戳
            this.$myhttp.get('admin/region?search='+ this.search + '&id=1'+'&t='+t+"&pid="+pid,{
                'Content-Type': 'application/json'
                }).then(backdata=>{ // 异步执行成功后
                this.desserts = backdata.data[0];
                this.total = backdata.data[1];
                this.page = backdata.data[2];
                this.$Loading.finish();
              ERP.hideLoading()
            });
        },
        //删除
        del(e){
            var t = Date.parse(new Date()) / 1000;//时间戳
            this.$confirm('确定要删除吗, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                this.$Loading.start();
                this.$myhttp.post('admin/regiondel',{id:e},{
                    'Content-Type': 'application/x-www-form-urlencoded'
                    }).then(backdata=>{ // 异步执行成功后
                    if(backdata.data['code'] == 60006){
                        this.$Loading.finish();
                        this.$Message.error(backdata.data['date']);
                        return false;
                    }
                    if(backdata.data == 1){
                        this.dela = true;
                        var pid = this.items.id;
                        this.$myhttp.get('admin/region?id=1'+'&t='+t+"&pid="+pid,{
                        'Content-Type': 'application/json'
                        }).then(backdata=>{ // 异步执行成功后
                            this.desserts = backdata.data[0];
                            this.total = backdata.data[1];
                            this.$Loading.finish();
                            this.$Message.success('删除成功!');
                        });
                    }
                });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        //添加保存
        ok () {
            if(this.dades.name == ""){
                this.$Message.error('区域名称不能为空!');
                this.loading();
                return false;
            }
            if(this.$refs.tree.getCheckedKeys().length == 0){
                this.$Message.error('选择不能为空!');
                this.loading();
                return false;
            }
            var id = this.$refs.tree.getCheckedKeys();//获得全选状态id(回显用)
            var ids = this.$refs.tree.getCheckedNodes();//获得全选状态id数组（保存遍历出住宅用）
            var pid = this.items.id;
            this.dades.list = ids;
            this.dades.pid = pid;
            this.dades.listid = id;
            this.$Loading.start();
            this.$myhttp.post('admin/regionAdd',this.dades,{
                'Content-Type': 'application/x-www-form-urlencoded'
                }).then(backdata=>{ // 异步执行成功后
                this.loading();
                if(backdata.data[0] == 1){
                    this.modal1 = false;
                    var t = Date.parse(new Date()) / 1000;//时间戳
                    var pid = this.items.id;
                    this.$myhttp.get('admin/region?id=1'+'&t='+t+"&pid="+pid,{
                    'Content-Type': 'application/json'
                    }).then(backdata=>{ // 异步执行成功后
                        this.desserts = backdata.data[0];
                        this.total = backdata.data[1];
                        this.$Loading.finish();
                    });
                    this.$Loading.finish();
                    this.$Message.success(backdata.data[1]);
                }else{
                    this.$Loading.finish();
                    this.$Message.error('编辑失败!');
                }
            });
        },
        //修改查询
        xiugai(e){
            this.$Loading.start();
            this.anxiu="修改";
            var pid = this.items.id;
            var name = this.items.name;
            var t = Date.parse(new Date()) / 1000;//时间戳
            this.$myhttp.get('admin/regionUpdeteGet?id='+e+'&t='+t+"&pid="+pid+"&name="+name,{
                'Content-Type': 'application/json'
                }).then(backdata=>{ // 异步执行成功后
                this.dades.id = backdata.data[2][0].id;
                this.dades.name = backdata.data[2][0].name;
                let data = backdata.data[0];
                //1级树
                this.dataarr = [{'label':data[0].label,'id':data[0].id,'region':0,'type':1,'pindex_id':data[0].id,superior:'0'}]
                this.defaultcheckedkeys = [];
                this.dadetree = backdata.data[1];
                this.$Loading.finish();
                this.modal1 = true;
            });
        },
        loading(){
          this.loadings = false;
          let _this = this;
          setTimeout(() => {
              _this.loadings = true;
          }, 100);
        }
    },
    //监听
    watch: {
     '$route' (to, from) { //监听路由是否变化
      if(to.path == "/pindex/regionDate"){
        var item = JSON.parse(this.$route.query.iten);
        this.items = item;

        this.$Loading.start();
        var pid = this.items.id;
        var t = Date.parse(new Date()) / 1000;//时间戳
        this.$myhttp.get('admin/region?id=1'+'&t='+t+"&pid="+pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.$Loading.finish();
        });
      }
    }
  },
}
</script>

<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.con{
  color: rgb(57, 136, 74);
}
.item{
  margin-top: 1%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/regionDate.vue